import { Component, Input, OnInit, OnChanges, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { AppMainComponent } from 'src/app/app.main.component';
import { GlobalSearchPath } from 'src/app/modules/shared/constants/global-search-path';
// import { LocalDatePipe } from 'src/app/shared/pipes/local-date.pipe';
import { LocalDatePipe } from 'src/app/modules/shared/pipes/local-date.pipe';
import { reportNames } from "../constants";
import { ReportsInventoryNames } from '../models/reports-inventory.models';
import { IPopupLink, IReportsColumnModel } from '../models/reports.models';
import { FinanceService } from 'src/app/finance/finance.service';
import { AccountsTransactionType, TransactionNames } from 'src/app/finance/constants/constants';
import { Subject, lastValueFrom, takeUntil } from 'rxjs';
import { ImportserialService } from 'src/app/modules/shared/services/importserial.service';

@Component({
    selector: 'app-table',
    templateUrl: './table.component.html',
    styleUrls: ['./table.component.scss'],
    providers: [LocalDatePipe]

})
export class TableComponent implements OnChanges {
    transactionNames = TransactionNames;
    displayInventoryOverview: boolean = false;
    inventoryOverviewRefId: number = 0;
    inventoryOverviewRefNumber: string = "";
    inventoryOverviewModule: string = "";
    showRows = 15;
    reportNames = reportNames;

    @Input() showTitle: boolean = true;
    @Input() selectedWindow;
    @Input() reportName;
    @Input() reportDate;
    @Input() reportDatas = [];
    @Input() reportTotalRow = {};
    @Input() groupWiseReportTotalRow = {};
    @Input() reportType;
    @Input() cols = [];//: IReportsColumnModel[] = [];
    @Input() groupTypeColName = ''; //Group column name
    @Input() detailsCols = [];
    @Input() detailsType;
    @Input() detailsHeader = '';
    @Input() detailsGroupTypeColName = ''; //Details Group column name
    @Input() detailsHeaderTitle = '';
    @Input() showInActive: boolean = false;
    @Input() showTotal;
    noData = "No Reports Available."

    @Input() chartLabel;
    @Input() chartType;
    @Input() stackedBar = [];
    @Input() stackedOptions;
    @Input() barData = [];
    @Input() basicOptions;
    @Input() totalRecords: number;

    @Input() filterDataByLeadStage;
    @Input() dateFrom;
    @Input() dateTo;
    @Input() reportRowDetails = [];
    @Output() camelize = new EventEmitter;
    @Output() monthList = new EventEmitter;
    @Output() onTableRowClick: EventEmitter<any> = new EventEmitter<any>();
    @Output() onTableRowDetailsExportClick: EventEmitter<any> = new EventEmitter<any>();
    @Output() onShowInActiveClick: EventEmitter<any> = new EventEmitter<any>();
    @Output() onClickPaginationData: EventEmitter<any> = new EventEmitter<any>();
    @Output() onPopupLinkClick: EventEmitter<IPopupLink> = new EventEmitter<IPopupLink>();
    protected ngUnsubscribe$: Subject<void> = new Subject<void>();
    reports = [
        {
            "id": 1,
            "name": "Harry Singh",
            "visitCount": 35,
            "dayCount": 5,
            "averageVisit": 7,
            "averageSpend": "00:30 hrs"
        }
    ]
    first = 0;
    detailFirst = 0;
    tableShowMore: number[] = null;
    selectedData;
    displayDetails = false;
    today = new Date();

    displaySettings = false;
    organizationName: string = '';
    ReportsInventoryNames = ReportsInventoryNames;
    displayInvoicingAdd = false;
    selectedInvoiceId = false;

    overviewRefId: any = 0;
    transactionMasterId: number = 0;
    overviewRefNumber: string = "";
    displayWriteCheck: boolean = false;
    displayAddEditExpense: boolean = false;
    displayCreditCardViewDialog: boolean = false;
    displayBankRegisterViewDialog: boolean = false;
    displayJournalEntryViewDialog: boolean = false;
    isView: boolean = true;
    fractionDigits: number = 0;

    constructor(public app: AppMainComponent,
        private router: Router, 
        private financeService: FinanceService,
        private importService: ImportserialService) { }

    // ngOnInit(): void {
    //     this.organizationName = this.app.user.organizationName;
    //     console.log("On Init Total Row:", this.reportTotalRow);
    // }

    ngOnChanges(changes: SimpleChanges): void {
        this.getFractionDigits();
        // console.log(this.cols);
        if (changes?.reportDatas?.currentValue) {
            this.reportDatas = changes?.reportDatas?.currentValue;
            this.generateShowMore(this.reportDatas?.length);
            this.resetPagination();
        }
        if (changes?.reportRowDetails?.currentValue) {
        }
        this.getInventoryReports();
        let arr = [];
        for (let s of this.reportDatas) {
            s.id = arr.length + 1;
            arr.push(s)
        }
        this.reportDatas = JSON.parse(JSON.stringify(arr));
        //console.log(this.reportDatas, this.cols, this.selectedWindow, this.groupWiseReportTotalRow);
    }

    generateShowMore(counts: number = 0) {
        this.tableShowMore = null;
        this.showRows = 15;
        if (this.reportType == "simpleTBWithAPIPagination") {
            this.tableShowMore = [this.showRows, 30, 50, 100];
        }
        else if (counts > this.showRows) {
            this.tableShowMore = [this.showRows, 30];

            if (counts > 30) {
                this.tableShowMore.push(50);
            }

            if (counts > 50) {
                this.tableShowMore.push(100);
            }
        }
    }
    //Rset the pagination
    resetPagination() {
        this.first = 0;
    }
    //Rset the pagination
    resetDetailsPagination() {
        this.detailFirst = 0;
    }
    getInventoryReports() {
        switch (this.selectedWindow) {
            case 'avareagefieldvisitbyrep': {
                this.cols = [
                    { field: 'repName', header: 'Rep Name' },
                    { field: 'visitCount', header: 'Geo Matched' },
                    { field: 'dayCount', header: 'Day Counts' },
                    { field: 'averageVisitsPerDay', header: 'Average Visits per day' },
                    { field: 'timeSpent', header: 'Average Time Spent per Account' },
                ];
                this.reportName = reportNames.averageFieldVisitsByRep;
                // console.log("cols", this.cols);
                break;
            }
            //crm
            case 'activityAnalyticReportSummary': {
                this.cols = [
                    { field: 'activityChannel', header: 'Activity Channel' },
                    { field: 'totalCount', header: 'Total Count' },
                ];
                this.reportName = 'Activity Analytic Report Summary';
                break;
            }
            case 'activityAnalyticReportDetail': {
                this.cols = [
                    { field: 'accountName', header: 'Account Name' },
                    { field: 'channelType', header: 'Channel Type' },
                    { field: 'comment', header: 'Comment' },
                    { field: 'loggedBy', header: 'Logged By' },
                    { field: 'activityCreatedDate', header: 'Date & Time' },
                    { field: 'territoryName', header: 'Territory Name' },
                    { field: 'moduleName', header: 'Module Name' },
                    { field: 'address', header: 'Address' },
                ];
                this.reportName = 'Activity Analytic Report Detail';
                break;
            }
            case 'accountsActivityReport': {
                this.cols = [
                    { field: 'accountName', header: 'Account Name' },
                    { field: 'channelType', header: 'Channel Type' },
                    { field: 'comment', header: 'Comment' },
                    { field: 'logdatetime', header: 'Created Date' },
                    { field: 'loggedBy', header: 'Created By' },
                    { field: 'territoryName', header: 'Territory Name' },
                    { field: 'address', header: 'Address' },
                ];
                this.reportName = 'Activity Report';
                break;
            }
            case 'accountsNoActivityReport': {
                this.cols = [
                    { field: 'accountName', header: 'Account Name' },
                    { field: 'activityType', header: 'Last Activity Type' },
                    { field: 'comment', header: 'Comment' },
                    { field: 'logdatetimeUTC', header: 'Last Activity Date' },
                    { field: 'repName', header: 'Logged By' },
                    { field: 'territoryName', header: 'Territory Name' },
                    { field: 'address', header: 'Address' },
                ];
                this.reportName = 'No Activity Report';
                break;
            }
            case 'keyAccountsReportSummary': {
                this.cols = [
                    { field: 'accountName', header: 'Account Name' },
                    { field: 'noofOpportunity', header: 'No. Of Opportunities' },
                    { field: 'amount', header: 'Amount' },
                ];
                this.reportName = 'Key Accounts Summary';
                break;
            }
            case 'keyAccountsReportDetails': {
                this.cols = [
                    { field: 'accountName', header: 'Account Name' },
                    { field: 'opportunityName', header: 'Opportunity Name' },
                    { field: 'closingDate', header: 'Closing Date' },
                    { field: 'stage', header: 'Stage' },
                    { field: 'amount', header: 'Amount' },
                ];
                this.reportName = 'Key Accounts Details';
                break;
            }
            //cases
            case 'casesByCategorySummary': {
                this.cols = [
                    { field: 'categoryName', header: 'Category' },
                    { field: 'subCategory', header: 'Sub-Category' },
                    { field: 'channel', header: 'Channel' },
                    { field: 'status', header: 'Status' },
                    { field: 'totalCases', header: 'Total Cases' },
                ];
                this.reportName = 'Cases By Category Summary';
                break;
            }
            case 'casesByCategoryDetails': {
                this.cols = [
                    { field: 'categoryName', header: 'Category' },
                    { field: 'subCategory', header: 'Sub-Category' },
                    { field: 'channel', header: 'Channel' },
                    { field: 'status', header: 'Status' },
                    { field: 'stage', header: 'Stage' },
                    { field: 'ticketId', header: 'Ticket No.' },
                    { field: 'createBy', header: 'Created By' },
                    { field: 'createDate', header: 'Created Date' },
                ];
                this.reportName = 'Cases By Category Details';
                break;
            }
            case 'casesByRepSummary': {
                this.cols = [
                    { field: 'assignedUser', header: 'Assigned User' },
                    { field: 'channel', header: 'Channel' },
                    { field: 'status', header: 'Status' },
                    { field: 'totalCases', header: 'Total Cases' },
                ];
                this.reportName = 'Cases By Rep Summary';
                break;
            }
            case 'casesByRepDetails': {
                this.cols = [
                    { field: 'assignedUser', header: 'Assigned User' },
                    { field: 'channel', header: 'Channel' },
                    { field: 'status', header: 'Status' },
                    { field: 'stage', header: 'Stage' },
                    { field: 'ticketId', header: 'Ticket No.' },
                    { field: 'createBy', header: 'Created By' },
                    { field: 'createDate', header: 'Created Date' },
                ];
                this.reportName = 'Cases By Rep Details';
                break;
            }
            case 'casesBySourceSummary': {
                this.cols = [
                    { field: 'sourceName', header: 'Source' },
                    { field: 'channel', header: 'Channel' },
                    { field: 'status', header: 'Status' },
                    { field: 'totalCases', header: 'Total Cases' },
                ];
                this.reportName = 'Cases By Source Summary';
                break;
            }
            case 'casesBySourceDetails': {
                this.cols = [
                    { field: 'sourceBox', header: 'Source' },
                    { field: 'channel', header: 'Channel' },
                    { field: 'status', header: 'Status' },
                    { field: 'stage', header: 'Stage' },
                    { field: 'ticketNo', header: 'Ticket No.' },
                    { field: 'createBy', header: 'Created By' },
                    { field: 'createDate', header: 'Created Date' },
                ];
                this.reportName = 'Cases By Source Details';
                break;
            }
            case 'casesByAccounts': {
                this.cols = [
                    { field: 'channel', header: 'Channel' },
                    { field: 'accountName', header: 'Account Name' },
                    { field: 'assignedUser', header: 'Assigned User' },
                    { field: 'ticketNo', header: 'Ticket No.' },
                    { field: 'categoryName', header: 'Category' },
                    { field: 'subCategory', header: 'Sub-Category' },
                    { field: 'status', header: 'Status' },
                    { field: 'stage', header: 'Stage' },
                    { field: 'createBy', header: 'Created By' },
                    { field: 'createDate', header: 'Created Date' },
                    { field: 'updateDate', header: 'Updated Date' },
                ];
                this.reportName = 'Cases By Accounts';
                break;
            }
            case 'casesByLeads': {
                this.cols = [
                    { field: 'channel', header: 'Channel' },
                    { field: 'leadName', header: 'Lead Name' },
                    { field: 'assignedUser', header: 'Assigned User' },
                    { field: 'ticketNo', header: 'Ticket No.' },
                    { field: 'categoryName', header: 'Category' },
                    { field: 'subCategory', header: 'Sub-Category' },
                    { field: 'status', header: 'Status' },
                    { field: 'stage', header: 'Stage' },
                    { field: 'createBy', header: 'Created By' },
                    { field: 'createDate', header: 'Created Date' },
                    { field: 'updateDate', header: 'Updated Date' },
                ];
                this.reportName = 'Cases By Leads';
                break;
            }
            //leads
            case 'leadsIndustry': {
                this.cols = [
                    { field: 'industry', header: 'Industry' },
                    { field: 'leadOwner', header: 'Lead Owner' },
                ];
                for (var i = 0; i < this.filterDataByLeadStage.length; i++) {
                    var leadStageName = this.filterDataByLeadStage[i].name + "";
                    if (leadStageName.toLowerCase() !== 'all')
                        this.cols.push({ field: this.camelizeChild(leadStageName), header: leadStageName });
                }
                this.cols.push({ field: 'grandTotal', header: 'Grand Total' },);
                this.reportName = 'Lead by Industry';
                break;
            }
            case 'leadsActivity': {
                this.cols = [
                    { field: 'leadName', colspan: '2', header: 'Lead Name' },
                    { field: 'channel', header: 'Channel' },
                    { field: 'activityType', header: 'Activity Type' },
                    { field: 'comment', colspan: '3', header: 'Comment' },
                    { field: 'createDate', header: 'Created Date' },
                    { field: 'createdBy', header: 'Created By' },
                    { field: 'address', header: 'Address' },
                ];
                this.reportName = 'Lead by Activity';
                break;
            }
            case 'leadsConversion': {
                this.cols = [
                    { field: 'leadName', header: 'Lead Name' },
                    { field: 'leadSource', header: 'Lead Source' },
                    { field: 'leadCreatedDate', header: 'Lead Created Date' },
                    { field: 'primaryAssociate', header: 'Primary Associate' },
                    { field: 'convertedAccountName', header: 'Converted AccountName' },
                    { field: 'convertedDate', header: 'Converted Date' },
                    { field: 'convertedBy', header: 'Converted By' },
                ];
                this.reportName = 'Lead by Conversion';
                break;
            }
            case 'leadsConversionSummary': {
                this.cols = [
                    { field: 'primaryAssociate', header: 'Primary Associate' },
                    { field: 'leadCreated', header: 'Lead Created' },
                    { field: 'leadConverted', header: 'Lead Converted' },
                    { field: 'leadConversionRate', header: 'Lead Conversion Rate' },
                ];
                this.reportName = 'Lead by Conversion Summary';
                break;
            }
            case 'leadsType': {
                this.cols = [
                    { field: 'leadType', header: 'Lead Type' },
                    { field: 'leadOwner', header: 'Lead Owner' },
                ];
                for (var i = 0; i < this.filterDataByLeadStage.length; i++) {
                    var leadStageName = this.filterDataByLeadStage[i].name + "";
                    if (leadStageName.toLowerCase() !== 'all')
                        this.cols.push({ field: this.camelizeChild(leadStageName), header: leadStageName });
                }
                this.cols.push({ field: 'grandTotal', header: 'Grand Total' },);
                this.reportName = 'Lead by Type';
                break;
            }
            case 'leadsSource': {
                this.cols = [
                    { field: 'source', header: 'Source' },
                    { field: 'leadOwner', header: 'Lead Owner' },
                ];
                for (var i = 0; i < this.filterDataByLeadStage.length; i++) {
                    var leadStageName = this.filterDataByLeadStage[i].name + "";
                    if (leadStageName.toLowerCase() !== 'all')
                        this.cols.push({ field: this.camelizeChild(leadStageName), header: leadStageName });
                }
                this.cols.push({ field: 'grandTotal', header: 'Grand Total' },);
                this.reportName = 'Lead by Source';
                break;
            }
            case 'leadsCreatedate': {
                let months = this.monthListChild(new Date(this.dateFrom), new Date(this.dateTo));
                this.cols = [
                    { field: 'leadStage', header: 'Lead Stage' },
                    { field: 'leadOwner', header: 'Lead Owner' },
                ];
                // for (var i = 0; i < months.length; i++) {
                //   var monthName = months[i] + "";
                //   this.cols.push({ field: monthName.toLowerCase(), header: monthName });
                // }
                this.cols.push({ field: 'grandTotal', header: 'Grand Total' },);
                this.reportName = 'Lead by Create Date';
                break;
            }
            case 'leadsNoActivity': {
                this.cols = [
                    { field: 'leadName', header: 'Lead Name' },
                    { field: 'channel', header: 'Channel' },
                    { field: 'activityType', header: 'Activity Type' },
                    { field: 'comment', header: 'Comment' },
                    { field: 'createdDate', header: 'Last Updated Date' },
                    { field: 'createdBy', header: 'Created By' },
                    { field: 'address', header: 'Address' },
                ];
                this.reportName = 'Lead by No Activity';
                break;
            }
            case 'leadsAging': {
                this.cols = [
                    { field: 'LeadName', header: 'Lead Name' },
                    { field: 'PrimaryAssocite', header: 'Primary Associte' },
                    { field: 'CurrentStage', header: 'Current Stage' },
                    { field: 'CreatedDate', header: 'Created Date' },
                    { field: 'TotalAge', header: 'Total Age' },
                ];
                this.reportName = 'Lead by Aging';
                break;
            }
            case 'leadsConverted': {
                var months = this.monthListChild(new Date(this.dateFrom), new Date(this.dateTo));
                this.cols = [{ field: 'leadOwner', header: 'Lead Owner' }];
                // for (var i = 0; i < months.length; i++) {
                //     var monthName = months[i] + "";
                //     this.cols.push({ field: monthName.toLowerCase(), header: monthName });
                // }
                this.cols.push({ field: 'grandTotal', header: 'Grand Total' },);
                this.reportName = 'Lead by Converted';
                break;
            }

            //inventory
            // case 'accountsRec': {
            //     this.cols = [
            //         { field: 'accountName', header: 'Account Name' },
            //         { field: 'channel', header: 'Channel Name' },
            //         { field: 'current', header: 'Current' },
            //         { field: '30', header: '31 - 60' },
            //         { field: '60', header: '61 - 90' },
            //         { field: '90', header: '> 90' },
            //         { field: 'total', header: 'Total' },
            //     ];
            //     this.reportName = 'Accounts receivable';
            //     break;
            // }
            // case 'inventorySummary': {
            //     this.cols = [
            //         { field: 'location', header: 'Location' },
            //         { field: 'itemNo', header: 'Item No.' },
            //         { field: 'itemName', header: 'Item Name' },
            //         { field: 'qoh', header: 'QOH' },
            //         { field: 'avgCost', header: 'Avg Cost' },
            //         { field: 'assetValue', header: 'Asset Value' },
            //         { field: 'salesPrice', header: 'Sales Price' },
            //         { field: 'assetPer', header: '% of Total Asset' },
            //     ];
            //     this.reportName = 'Inventory Valuation Summary';
            //     break;
            // }
            /*case 'inventoryDetail': {
                this.cols = [
                    { field: 'date', header: 'Date' },
                    { field: 'type', header: 'Tx Type' },
                    { field: 'txId', header: 'Tx ID' },
                    { field: 'name', header: 'Name' },
                    { field: 'qty', header: 'Qty' },
                    { field: 'cost', header: 'Cost' },
                    { field: 'totalCost', header: 'Total Cost' },
                    { field: 'qoh', header: 'QOH' },
                    { field: 'assetValue', header: 'Asset Value' },
                ];
                this.reportName = 'Inventory Valuation Detail';
                this.reportDatas = [
                    {
                        "id": 1,
                        "itemName": "IPH13: Iphone13 Pro",
                        "children": [
                            {
                                "id": 1,
                                "date": "09/23/2022",
                                "type": "Beginning Balance",
                                "txId": "SN9982",
                                "name": "Cellphone",
                                "qty": 40,
                                "cost": "$30",
                                "totalCost": "$800",
                                "qoh": "50",
                                "assetValue": "$400",
                            },
                            {
                                "id": 2,
                                "date": "09/23/2022",
                                "type": "Invoice",
                                "txId": "SN9982",
                                "name": "Cellphone",
                                "qty": 40,
                                "cost": "$30",
                                "totalCost": "$800",
                                "qoh": "50",
                                "assetValue": "$400",
                            },
                        ]
                    },
                    {
                        "id": 2,
                        "itemName": "IPH13: Iphone13 Pro",
                        "children": [
                            {
                                "id": 1,
                                "date": "09/23/2022",
                                "type": "Beginning Balance",
                                "txId": "SN9982",
                                "name": "Cellphone",
                                "qty": 40,
                                "cost": "$30",
                                "totalCost": "$800",
                                "qoh": "50",
                                "assetValue": "$400",
                            },
                            {
                                "id": 2,
                                "date": "09/23/2022",
                                "type": "Invoice",
                                "txId": "SN9982",
                                "name": "Cellphone",
                                "qty": 40,
                                "cost": "$30",
                                "totalCost": "$800",
                                "qoh": "50",
                                "assetValue": "$400",
                            },
                        ]
                    },
                ];
                break;
            }/*
            case 'snapshot': {
                this.cols = [
                    { field: 'location', header: 'Location ID', isShow: true, isMoved: false },
                    { field: 'qoh', header: 'QOH', isShow: true, isMoved: true },
                    { field: 'atp', header: 'ATP', isShow: true, isMoved: true },
                    { field: 'qtyOnOrder', header: 'Qty On Order', isShow: true, isMoved: true },
                    { field: 'qtyCommitted', header: 'Qty Committed', isShow: true, isMoved: true },
                    { field: 'reorderPoint', header: 'Reorder Point', isShow: true, isMoved: true },
                    { field: 'qtyToOrder', header: 'Qty to Order', isShow: true, isMoved: true },
                    { field: 'stockLevel', header: 'Pref Stock Level', isShow: true, isMoved: true },
                ];
                this.reportName = 'Current Inventory Snapshot Report';
                this.reportDate = '09-06-2022'
                this.reportDatas = [
                    {
                        "id": 1,
                        "itemName": "I029323 - Iphone13 Pro",
                        "children": [
                            {
                                "id": 1,
                                "location": "NY",
                                "qoh": 50,
                                "atp": 50,
                                "qtyOnOrder": 900,
                                "qtyCommitted": 800,
                                "reorderPoint": "",
                                "qtyToOrder": 700,
                                "stockLevel": 500
                            }
                        ]
                    }
                ]
                break;
            }
            /*case 'profitability': {
                this.cols = [
                    { field: 'itemNo', header: 'Item No.' },
                    { field: 'desc', header: 'Item Details' },
                    { field: 'location', header: 'Location' },
                    { field: 'qty', header: 'Qty Sold' },
                    { field: 'revenue', header: 'Total Revenue' },
                    { field: 'grossProfit', header: 'Gross Profit' },
                    { field: 'totalPer', header: 'Total Profit %' },
                    { field: 'grossPer', header: 'Gross Profit %' }
                ];
                this.reportName = 'Inventory Profitability Report';
                break;
            }*/
            // case 'inventoryopeninvoice': {
            //     this.cols = [
            //         { field: 'invoicedate', header: 'Invoice Date' },
            //         { field: 'invoicenumber', header: 'Invoice No' },
            //         { field: 'accountname', header: 'Account Name' },
            //         { field: 'channelname', header: 'Channel Name' },
            //         { field: 'invoiceduedate', header: 'Due Date' },
            //         { field: 'dueamount', header: 'Amount Due' },
            //         { field: 'comment', header: 'Memo' },
            //     ];
            //     //  this.reportName = 'Open Invoices Report';
            //     break;
            // }
            /*case 'allInvoices': {
                this.cols = [
                    { field: 'invoiceDate', header: 'Invoice Date' },
                    { field: 'invoiceNo', header: 'Invoice No.' },
                    { field: 'pStatus', header: 'Payment Status' },
                    { field: 'oStatus', header: 'Order Status' },
                    { field: 'channel', header: 'Channel Name' },
                    { field: 'accountName', header: 'Account Name' },
                    { field: 'amount', header: 'Amount Due' },
                    { field: 'memo', header: 'Memo' }
                ];
                this.reportName = 'All Invoices Report';
                break;
            }
            case 'shipping': {
                this.cols = [
                    { field: 'channel', header: 'Channel Name' },
                    { field: 'accountName', header: 'Account Name' },
                    { field: 'street', header: 'Street Addr.' },
                    { field: 'city', header: 'City' },
                    { field: 'state', header: 'State' },
                    { field: 'zipcode', header: 'Zip Code' },
                    { field: 'weight', header: 'Weight' },
                    { field: 'invoiceNo', header: 'Invoice No.' },
                    { field: 'invoiceDate', header: 'Invoice Date' },
                    { field: 'shippingMethod', header: 'Shipping Method' },
                    { field: 'tracking', header: 'Tracking No.' },
                ];
                this.reportName = 'Shipping Report';
                break;
            }*/
            // case 'openSO': {
            //     this.cols = [
            //         { field: 'soDate', header: 'SO Date' },
            //         { field: 'soNo', header: 'SO No.' },
            //         { field: 'soStatus', header: 'SO Status' },
            //         { field: 'soStage', header: 'SO Stage' },
            //         { field: 'location', header: 'Location' },
            //         { field: 'channel', header: 'Channel Name' },
            //         { field: 'accountName', header: 'Account Name' },
            //         { field: 'createdBy', header: 'Created By' },
            //         { field: 'repName', header: 'Rep Name' },
            //         { field: 'amount', header: 'Amount Due' },
            //     ];
            //     this.reportName = 'Open Sales Orders Report';
            //     break;
            // }
            // case 'backOrder': {
            //     this.cols = [
            //         { field: 'soDate', header: 'SO Date' },
            //         { field: 'soNo', header: 'SO No.' },
            //         { field: 'itemName', header: 'Item Name' },
            //         { field: 'channel', header: 'Channel Name' },
            //         { field: 'accountName', header: 'Account Name' },
            //         { field: 'ordQty', header: 'Ord Qty' },
            //         { field: 'shipQty', header: 'Ship Qty' },
            //         { field: 'backQty', header: 'BKO Qty' },
            //         { field: 'qoh', header: 'QOH' },
            //         { field: 'atp', header: 'ATP' },
            //     ];
            //     this.reportName = 'Sales Back Order Report';
            //     break;
            // }
            /*case 'commited': {
                this.cols = [
                    { field: 'soDate', header: 'SO Date' },
                    { field: 'soNo', header: 'SO No.' },
                    { field: 'soStatus', header: 'SO Status' },
                    { field: 'soStage', header: 'SO Stage' },
                    { field: 'location', header: 'Location' },
                    { field: 'channel', header: 'Channel Name' },
                    { field: 'accountName', header: 'Account Name' },
                    { field: 'createdBy', header: 'Created By' },
                    { field: 'repName', header: 'Rep Name' },
                    { field: 'amount', header: 'Amount' },
                ];
                this.reportName = 'Sales Order Committed Report';
                break;
            }
            case 'picktime': {
                this.cols = [
                    { field: 'soDate', header: 'SO Date' },
                    { field: 'soNo', header: 'SO No.' },
                    { field: 'soStage', header: 'SO Stage' },
                    { field: 'location', header: 'Location' },
                    { field: 'channel', header: 'Channel Name' },
                    { field: 'pickerName', header: 'Picker Name' },
                    { field: 'picktime', header: 'Avg Pick Time (hh:mm:ss)' },
                ];
                this.reportName = 'Sales Order Average Pick time Report';
                this.reportDatas = [
                    {
                        "id": 1,
                        "soDate": "09/23/2022",
                        "soNo": "SN9982",
                        "soStage": "Pick",
                        "location": "NY",
                        "channel": "Default",
                        "accountName": "ABC Wireless",
                        "pickerName": "John",
                        "picktime": "01:44:23"
                    }
                ];
                this.detailsHeader = "Pick Time by Picker";
                this.selectedData = null;
                this.detailsCols = [
                    { field: 'soDate', header: 'SO Date' },
                    { field: 'soNo', header: 'SO No.' },
                    { field: 'location', header: 'Location' },
                    { field: 'accountName', header: 'Account Name' },
                    { field: 'pickQty', header: 'Total Picked Qty' },
                    { field: 'total', header: 'Order Total' },
                    { field: 'picktime', header: 'Pick Time' },
                ]
                break;
            }
            case 'packtime': {
                this.cols = [
                    { field: 'soDate', header: 'SO Date' },
                    { field: 'soNo', header: 'SO No.' },
                    { field: 'soStage', header: 'SO Stage' },
                    { field: 'location', header: 'Location' },
                    { field: 'channel', header: 'Channel Name' },
                    { field: 'packerName', header: 'Packer Name' },
                    { field: 'packtime', header: 'Avg Pack Time (hh:mm:ss)' },
                ];
                this.reportName = 'Sales Order Average Pack time Report';
                this.reportDatas = [
                    {
                        "id": 1,
                        "soDate": "09/23/2022",
                        "soNo": "SN9982",
                        "soStage": "Pick",
                        "location": "NY",
                        "channel": "Default",
                        "accountName": "ABC Wireless",
                        "packerName": "John",
                        "packtime": "01:44:23"
                    }
                ];
                this.detailsHeader = "Pack Time by Packer";
                this.selectedData = null;
                this.detailsCols = [
                    { field: 'soDate', header: 'SO Date' },
                    { field: 'soNo', header: 'SO No.' },
                    { field: 'location', header: 'Location' },
                    { field: 'accountName', header: 'Account Name' },
                    { field: 'pickQty', header: 'Total Packed Qty' },
                    { field: 'total', header: 'Order Total' },
                    { field: 'packtime', header: 'Pack Time' },
                ]
                break;
            }
            /*case 'accountsPayable': {
                this.cols = [
                    { field: 'current', header: 'Current' },
                    { field: '30', header: '31 - 60' },
                    { field: '60', header: '61 - 90' },
                    { field: '90', header: '> 90' },
                    { field: 'total', header: 'Total' },
                ];
                this.reportName = 'Accounts Payable';
                break;
            }*/
        }
    }

    camelizeChild(e) {
        this.camelize.emit(e);
    }
    monthListChild(a, b) {
        this.monthList.emit({ a, b });
    }

    showDetails(row: { data: any }) {
        this.displayDetails = true;
        this.reportRowDetails = [];
        //reset table row details pagination
        this.resetDetailsPagination();
        this.onTableRowClick.emit(row.data);
    }

    openSetting() {
        this.displaySettings = true;
    }
    cancelSetting() {
        this.displaySettings = false;
    }


    //#region //********Export(PDF & Excel)***********//

    onTableRowDetailsPrintXLSX(type: 'print' | 'PDF' | 'XLSX') {
        this.onTableRowDetailsExportClick.emit(type);
    }
    findTransactionType(obj, value) {
        return Object.keys(obj).find(key => obj[key] === value);
    }

    onRouteNavigation(rowData: any, col: IReportsColumnModel) {
        switch (rowData.txnType) {
            case AccountsTransactionType.Check:
                this.getReferenceId(rowData);
                this.openWriteCheckDialog(rowData);
                break;
            case AccountsTransactionType.Expense:
                this.getReferenceId(rowData);
                this.openExpenseDialog(rowData);
                break;
            case AccountsTransactionType.CreditCharges:
                this.getReferenceId(rowData);
                this.openCreditChargeDialog(rowData);
                break;
            case AccountsTransactionType.BankRegister:
                this.getReferenceId(rowData);
                this.openBankRegisterDialog(rowData);
                break;
            case AccountsTransactionType.JournalEntry:
                const accountsTransactionType = this.getTransactionTypeName(AccountsTransactionType.JournalEntry) 
                this.openJournalEntryDialog(rowData,accountsTransactionType);
                break;
            default:
                this.showInventoryDialog(rowData);
        }
    }

    //Inventory Overview
    showInventoryDialog(rowData) {
        const AccTranKey = this.findTransactionType(AccountsTransactionType, rowData.txnType || rowData.invoicestatusid || rowData.txnTypeId);
        if (AccTranKey == 'SalesReturn') {
            this.inventoryOverviewModule = TransactionNames.CreditMemo;
        } else if (AccTranKey == 'ReceivePayment') {
            this.inventoryOverviewModule = TransactionNames.Invoice;
        }
        else {
            this.inventoryOverviewModule = TransactionNames[AccTranKey];
        }
        this.inventoryOverviewRefId = rowData.invoiceid || rowData.invoiceId || rowData.invId || rowData.purchaseorderid || rowData.salesOrderId || rowData.salesorderid;
        this.inventoryOverviewRefNumber = rowData.invoiceno || rowData.invoiceNo || rowData.invoicenumber || rowData.invNo || rowData.purchaseordernumber || rowData.salesOrderNo || rowData.salesorderno;
        this.displayInventoryOverview = true
    }
    closeViewPopup() {
        this.displayInventoryOverview = false;
    }

    async getReferenceId(rowData) {
        this.overviewRefId = await lastValueFrom(this.financeService.getReferenceId(this.selectedWindow == 'accountsReceivable' ? rowData.invoiceid : rowData.purchaseorderid));
    }

    getTransactionTypeName(value: number): string | undefined {
        const keys = Object.keys(AccountsTransactionType).filter(key => isNaN(Number(key)));
        return keys.find(key => AccountsTransactionType[key as keyof typeof AccountsTransactionType] === value);
    }

    openWriteCheckDialog(rowData: any) {
        this.overviewRefNumber = rowData.invoiceno;
        this.displayWriteCheck = true;
    }
    onCloseWriteCheckDialog(e) {
        this.overviewRefId = 0;
        this.displayWriteCheck = false;
    }
    openExpenseDialog(rowData: any) {
        this.overviewRefNumber = rowData.invoiceno;
        this.displayAddEditExpense = true;
    }
    onCloseExpenseDialog(e) {
        this.overviewRefId = 0;
        this.displayAddEditExpense = false;
    }
    openCreditChargeDialog(rowData: any) {
        this.overviewRefNumber = rowData.invoiceno;
        this.displayCreditCardViewDialog = true;
    }
    onCloseCreditChargeDialog(e) {
        this.overviewRefId = 0;
        this.displayCreditCardViewDialog = false;
    }
    openBankRegisterDialog(rowData: any) {
        this.overviewRefNumber = rowData.invoiceno;
        this.transactionMasterId = rowData.accmasterid;
        this.displayBankRegisterViewDialog = true;
    }
    onCloseBankRegisterViewDialog(e) {
        this.overviewRefId = 0;
        this.displayBankRegisterViewDialog = false;
    }

    openJournalEntryDialog(rowData: any,accountsTransactionType) {
        this.inventoryOverviewRefNumber = rowData.purchaseordernumber;
        this.transactionMasterId = rowData.accmasterid;
        this.inventoryOverviewRefId = rowData.accmasterid;
        this.inventoryOverviewModule = TransactionNames[accountsTransactionType],
        this.isView = true;
        this.displayInventoryOverview = true;
    }
    onCancelJournalView(e){
        this.displayInventoryOverview = false;
    }

    onCloseJournalEntryDialog(e) {
        this.overviewRefId = 0;
        this.displayJournalEntryViewDialog = false;
    }

    onClickPopupLink(rowData: any, col: IReportsColumnModel) {
        this.onPopupLinkClick.emit({ rowData, col });
    }

    openInvoiceDialog(event: any) {
        this.selectedInvoiceId = event.invoiceId;
        // this.invoicingHeader = "Invoicing";
        this.displayInvoicingAdd = true;
        // this.invoicingDialogType = "VIEW";
        // this.selectedId = null;
    }
    onClickShowInActive() {
        this.onShowInActiveClick.emit(this.showInActive);
    }

    onInvoiceDialogCancel(event) {
        this.displayInvoicingAdd = false;
        //this.invoicingDialogType = "";
    }

    getPaginationData(event: any) {
        this.onClickPaginationData.emit(event);
    }

    getFractionDigits() {
        this.importService
            .getDecimalValue()
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe({
                next: (value) => {
                    if (value) {
                        this.fractionDigits = value;
                    }
                },
                error: (error) => { },
            });
    }
}
